<template>
  <v-container class="px-5 py-0 ma-0">
    <v-form ref="defaultsForm">
      <v-alert
        v-html="lang.config.defaults.alert"
        type="warning"
        class="mt-4"
        dense
      />
      <v-subheader>{{ lang.config.defaults.global.title }}</v-subheader>
      <v-row>
        <v-currency-field
          v-model="defaults_form.delivery_fee"
          :label="lang.config.defaults.global.delivery_fee"
          :loading="!socketInfo.firstLoad"
          :disabled="!socketInfo.firstLoad"
          class="pb-3"
          filled
          hide-details
        />
      </v-row>
      <v-row>
        <v-select
          v-model="defaults_form.default_state"
          :items="states"
          :label="lang.config.defaults.global.state"
          :loading="!socketInfo.firstLoad"
          :disabled="!socketInfo.firstLoad"
          class="pb-3"
          filled
          hide-details
        ></v-select>
      </v-row>
      <v-row>
        <v-select
          v-model="defaults_form.default_city"
          :items="cities"
          :label="lang.config.defaults.global.city"
          :loading="!socketInfo.firstLoad"
          :disabled="!socketInfo.firstLoad"
          class="pb-3"
          filled
          hide-details
        ></v-select>
      </v-row>
      <v-subheader>{{ lang.config.defaults.financial.title }}</v-subheader>
      <v-row>
        <v-text-field
          v-model="defaults_form.debit_tax"
          :label="lang.config.defaults.financial.debit_tax"
          :rules="lang.config.defaults.financial.rules.tax"
          :loading="!socketInfo.firstLoad"
          :disabled="!socketInfo.firstLoad"
          suffix="%"
          filled
        />
      </v-row>
      <v-row>
        <v-text-field
          v-model="defaults_form.credit_tax"
          :label="lang.config.defaults.financial.credit_tax"
          :rules="lang.config.defaults.financial.rules.tax"
          :loading="!socketInfo.firstLoad"
          :disabled="!socketInfo.firstLoad"
          suffix="%"
          filled
        />
      </v-row>
      <v-row>
        <v-checkbox
          v-model="defaults_form.discount_tax_comissions"
          :label="lang.config.defaults.financial.discount_tax_comissions"
          color="info"
          class="mt-0"
          hide-details
        />
      </v-row>
      <v-subheader>{{ lang.config.defaults.customers.title }}</v-subheader>
      <v-row>
        <v-textarea
          v-model="defaults_form.birthday_text"
          :label="lang.config.defaults.customers.birthday_text"
          filled
          auto-grow
          rows="2"
        />
      </v-row>
      <v-row>
        <v-btn
          @click="saveOptions()"
          :loading="get_interface.loading"
          :disabled="get_interface.loading"
          color="success"
          class="mt-4 mb-5 save-btn"
        >
          {{ lang.config.save }}
        </v-btn>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import defaults from '@/modules/default'
import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'
import statecities from '@/mixins/defaults/statecities'

export default {
  mixins: [ appdata, utils, statecities ],
  data () {
    return {
      first: true,
      defaults_form: { ...defaults.blank.options }
    }
  },
  watch: {
    'defaults_form.default_state': function (state) {
      if (state) this.cities = this.brasil[state].cities
    },
    get_options: function (newVal) {
      if (this.first) this.defaults_form = { ...newVal }
      this.first = false
    }
  },
  methods: {
    saveOptions () {
      this.$store.dispatch('saveMixed', { page: 9, type: 4, data: { id: 1, page: 'defaults', ...this.defaults_form }, ignoreResponseBar: false })
    }
  },
  created () {
    this.defaults_form = { ...this.get_options }
  }
}
</script>
